import Api from '@/services/Api'

export default {
	getAllClasificacionTasas(infoVigencia,calificacion,zscore) {
		return Api().get('clasificacionTasas/getAll/'+infoVigencia+'/'+calificacion+'/'+zscore)
	},
	clasificacionTasasByVigencia(vigencia){
		return Api().get('clasificacionTasas/clasificacionTasaByVigencia/'+vigencia)
	},
	createClasificacionTasas(datos){
		return Api().post('clasificacionTasas/create',datos)
	},
	updateClasificacionTasas(datos){
		return Api().put('clasificacionTasas/update',datos)
	}
}
